import React, { useCallback, useRef } from "react";
import ReusableTable from "./ReusableTable";
import { fetchSubscribers } from "../util/fetchUserUtil";

export const TelecomSuperMasters = () => {
  const fetchData = useCallback(async (postData) => {
    try {
      return await fetchSubscribers(postData, "super-masters");
    } catch (error) {
      const errorMessage =
        error?.response?.data?.data?.errorMessage ||
        error.message ||
        "An unknown error occurred";
      throw new Error(errorMessage);
    }
  }, []);

  const actionButtonsMeta = [
    {
      name: "New Super Master",
      action: "create_telecom_supermaster",
    },
  ];

  return (
    <>
      <ReusableTable
        key={"telecom_superMasters"}
        tableType={"telecom_superMasters"}
        tableName={"Super Masters"}
        needGlobalFilter={true}
        needPagination={true}
        onStateChange={fetchData}
        actionButtonsMeta={actionButtonsMeta}
        isExtendingReusableColumns={true}
      />
    </>
  );
};

export default TelecomSuperMasters;
